<template>
    <section>
        <div class="grid-container">
            <div class="grid-item">
                <welcome :userData="userData" />
                <filtro class="mt-3" @buscar="buscar($event)" :advanced="true" />
                <totalPatiens class="mt-3" :userData="userData" :dataDashboard="dataDashboard" :fechas="fechas" />
                <averageClinic class="mt-3" :userData="userData" :dataDashboard="dataDashboard" />
            </div>
            <div class="grid-item">
                <statistics :stadistics="stadistics" />
                <averages
                  class="mt-3"
                  :averages="averages"
                  :dates="fechas"
                  :count30="count30"
                  :count30ByDoctor="count30ByDoctor"
                  :membershipSummary="membershipSummary"
                  :byType="byType"
                />
                <statisticsPatients class="mt-3" :userData="userData" :dataDashboard="dataDashboard" />
                <visitTypes class="mt-3" :yearData="dataDashboard.year_data" :userData="userData" />
            </div>
        </div>
    </section>
</template>

<script>
import welcome from '../components/welcome.vue';
import filtro from '../components/filter';
import averageClinic from '../components/averageClinic';
import statisticsPatients from '../components/statisticsPatients';
import statistics from '../components/statistics';
import totalPatiens from '../components/totalPatiens';
import averages from "../components/averages"
import visitTypes from "../components/visitTypes.vue"
import { readDailyAverageValue } from '@/core/utils/dailyAverageFields'

export default {
    components: {
        averages,
        welcome,
        filtro,
        averageClinic,
        statisticsPatients,
        statistics,
        totalPatiens,
        visitTypes,
    },
    props: {
        userData: {
            type: Object,
            default: () => { },
            required: false
        },
        dataDashboard: {
            type: Object,
            default: () => { },
            required: false
        }
    },
    data() {
        return {
            stadistics: [],
            averages: [],
            fechas: {
                start: '',
                end: ''
            }
        }
    },
    computed: {
        count30() {
            const avg = this.dataDashboard?.average
            if (!avg || (avg.np_30_count == null && avg.nc_30_count == null)) return null
            return {
                np: parseInt(avg.np_30_count, 10) || 0,
                nc: parseInt(avg.nc_30_count, 10) || 0,
            }
        },
        byType() {
            return Array.isArray(this.dataDashboard?.average?.by_type)
                ? this.dataDashboard.average.by_type
                : []
        },
        membershipSummary() {
            return this.dataDashboard?.average?.summary?.membership || null
        },
        count30ByDoctor() {
            return Array.isArray(this.dataDashboard?.average?.np_nc_30_by_doctor_facility)
                ? this.dataDashboard.average.np_nc_30_by_doctor_facility
                : []
        },
    },
    watch: {
        dataDashboard: {
            handler(newData) {
                if (!newData || Object.keys(newData).length === 0) {
                    this.stadistics = [];
                    this.averages = [];
                    return;
                }

                this.stadistics = [
                    {
                        description: "Average diario del periodo de la fecha selecionada divido en los dias de ese periodo",
                        value: parseInt(newData.average?.income_days || 0),
                        title: "Daily Average Income"
                    },
                    {
                        description: "Average diario del periodo de la fecha selecionada divido en los dias de ese periodo",
                        value: parseInt(newData.average?.expenses_days || 0),
                        title: "Daily Average Expenses"
                    },
                    {
                        description: "(Daily Average Income) - (Daily Average Expences) - (Devolution)",
                        value: parseInt(newData.average?.net_income_days || 0),
                        title: "Net Average Income"
                    },
                    {
                        description: "Suma total del periodo de la fecha selecionada",
                        value: parseInt(newData.totals?.income || 0),
                        title: "Total Income"
                    },
                    {
                        description: "Suma total  del periodo de la fecha selecionada",
                        value: parseInt(newData.totals?.expenses || 0),
                        title: "Total Expenses"
                    },
                    {
                        description: "(Total Income ) - (Total Expences) - (Devolution)",
                        value: parseInt(newData.totals?.net_income || 0),
                        title: "Total net income"
                    },
                    {
                        description: "Suma total  del periodo de la fecha selecionada En Cash",
                        value: parseInt(newData.cash_cc?.cash || 0),
                        title: "Total income cash"
                    },
                    {
                        description: "Suma total  del periodo de la fecha selecionada en CC",
                        value: parseInt(newData.cash_cc?.cc || 0),
                        title: "Total Income CC"
                    },
                    {
                        description: "Suma total de los montos devueltos por cualquier motivo del periodo de la fecha selecionada",
                        value: parseInt(newData.total_refunds || 0),
                        title: "Total Devolution"
                    },
                ];

                this.averages = [
                    {
                        label: 'AVG_NC',
                        title: `Average NC $${newData.average?.nc || 0}`,
                        averages: newData.average?.nc_daily || []
                    },
                    {
                        label: 'AVG_NP',
                        title: `Average NP $${newData.average?.np || 0}`,
                        averages: newData.average?.np_daily || []
                    },
                    // Nuevos campos agregados
                    ...(newData.average?.cv_daily?.length ? [{
                        label: 'AVG_CV',
                        title: `Average CV $${this.typeAverage(newData, 'CV', newData.average.cv, newData.average.cv_daily, 'AVG_CV')}`,
                        averages: newData.average.cv_daily
                    }] : []),
                    ...(newData.average?.fu_daily?.length ? [{
                        label: 'AVG_FU',
                        title: `Average FU $${this.typeAverage(newData, 'F/U', newData.average.fu, newData.average.fu_daily, 'AVG_FU')}`,
                        averages: newData.average.fu_daily
                    }] : []),
                    ...(newData.average?.pi_daily?.length ? [{
                        label: 'AVG_PI',
                        title: `Average PI $${this.typeAverage(newData, 'P/I', newData.average.pi, newData.average.pi_daily, 'AVG_PI')}`,
                        averages: newData.average.pi_daily
                    }] : []),
                    ...(newData.average?.pp_daily?.length ? [{
                        label: 'AVG_PP',
                        title: `Average PP $${this.typeAverage(newData, 'P/P', newData.average.pp, newData.average.pp_daily, 'AVG_PP')}`,
                        averages: newData.average.pp_daily
                    }] : []),
                    ...(newData.average?.rs_daily?.length ? [{
                        label: 'AVG_RS',
                        title: `Average RS $${this.typeAverage(newData, 'R/S', newData.average.rs, newData.average.rs_daily, 'AVG_RS')}`,
                        averages: newData.average.rs_daily
                    }] : [])
                ];
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        typeAverage(data, prefix, backendValue, dailyData, fieldName) {
            const row = (data?.average?.by_type || []).find(item => item.prefix === prefix)
            if (row && row.average != null && row.average !== '') {
                return Math.trunc(Number(row.average) || 0)
            }
            if (backendValue != null && backendValue !== '') {
                return Math.trunc(Number(backendValue) || 0)
            }
            if (!dailyData || !dailyData.length) return 0
            const sum = dailyData.reduce(
                (acc, item) => acc + readDailyAverageValue(item, fieldName),
                0
            )
            return Math.round(sum / dailyData.length)
        },
        buscar(filtro) {
            this.fechas = {
                start: filtro.start,
                end: filtro.end
            }
            this.$emit('buscar', filtro)
        }
    }
}
</script>
<style lang="scss" scoped>
@import '../assets/cssDashboards.css';
</style>
